"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHILD_AGE_GENDER = void 0;
exports.CHILD_AGE_GENDER = Object.freeze({
    NO_CHILDREN_CHILD_AGE_QUOTA: 167,
    GIRLS_MONTHS: [
        112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 169, 171, 173, 175,
        177, 179, 181, 183, 185, 187, 189, 191, 193, 195, 197, 199, 201, 203, 205,
        207, 209, 211, 213, 215, 217, 219, 221, 223, 225, 227, 229, 231, 233,
    ],
    BOYS_MONTHS: [
        111, 113, 115, 117, 119, 121, 123, 125, 127, 129, 131, 168, 170, 172, 174,
        176, 178, 180, 182, 184, 186, 188, 190, 192, 194, 196, 198, 200, 202, 204,
        206, 208, 210, 212, 214, 216, 218, 220, 222, 224, 226, 228, 230, 232,
    ],
    GIRLS_YEARS: [
        134, 136, 138, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162,
        164, 166,
    ],
    BOYS_YEARS: [
        133, 135, 137, 139, 141, 143, 145, 147, 149, 151, 153, 155, 157, 159, 161,
        163, 165,
    ],
    GIRLS_CONDITIONS_CODES: [
        112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 169, 171, 173,
        175, 177, 179, 181, 183, 185, 187, 189, 136, 191, 193, 195, 197, 199, 201,
        203, 205, 207, 209, 211, 138, 213, 215, 217, 219, 221, 223, 225, 227, 229,
        231, 233, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162, 164,
        166,
    ],
    BOYS_CONDITIONS_CODES: [
        111, 113, 115, 117, 119, 121, 123, 125, 127, 129, 131, 133, 168, 170, 172,
        174, 176, 178, 180, 182, 184, 186, 188, 135, 190, 192, 194, 196, 198, 200,
        202, 204, 206, 208, 210, 137, 212, 214, 216, 218, 220, 222, 224, 226, 228,
        230, 232, 139, 141, 143, 145, 147, 149, 151, 153, 155, 157, 159, 161, 163,
        165,
    ],
    ALL_CONDITIONS_CODES: [
        {
            code: 111,
            age: 1,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 112,
            age: 1,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 113,
            age: 2,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 114,
            age: 2,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 115,
            age: 3,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 116,
            age: 3,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 117,
            age: 4,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 118,
            age: 4,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 119,
            age: 5,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 120,
            age: 5,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 121,
            age: 6,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 122,
            age: 6,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 123,
            age: 7,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 124,
            age: 7,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 125,
            age: 8,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 126,
            age: 8,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 127,
            age: 9,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 128,
            age: 9,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 129,
            age: 10,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 130,
            age: 10,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 131,
            age: 11,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 132,
            age: 11,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 133,
            age: 1,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 134,
            age: 1,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 135,
            age: 2,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 136,
            age: 2,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 137,
            age: 3,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 138,
            age: 3,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 139,
            age: 4,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 140,
            age: 4,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 141,
            age: 5,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 142,
            age: 5,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 143,
            age: 6,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 144,
            age: 6,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 145,
            age: 7,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 146,
            age: 7,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 147,
            age: 8,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 148,
            age: 8,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 149,
            age: 9,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 150,
            age: 9,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 151,
            age: 10,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 152,
            age: 10,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 153,
            age: 11,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 154,
            age: 11,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 155,
            age: 12,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 156,
            age: 12,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 157,
            age: 13,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 158,
            age: 13,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 159,
            age: 14,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 160,
            age: 14,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 161,
            age: 15,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 162,
            age: 15,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 163,
            age: 16,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 164,
            age: 16,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 165,
            age: 17,
            isBaby: false,
            isBoy: true,
        },
        {
            code: 166,
            age: 17,
            isBaby: false,
            isBoy: false,
        },
        {
            code: 167,
            age: 0,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 168,
            age: 13,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 169,
            age: 13,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 170,
            age: 14,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 171,
            age: 14,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 172,
            age: 15,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 173,
            age: 15,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 174,
            age: 16,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 175,
            age: 16,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 176,
            age: 17,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 177,
            age: 17,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 178,
            age: 18,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 179,
            age: 18,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 180,
            age: 19,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 181,
            age: 19,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 182,
            age: 20,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 183,
            age: 20,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 184,
            age: 21,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 185,
            age: 21,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 186,
            age: 22,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 187,
            age: 22,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 188,
            age: 23,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 189,
            age: 23,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 190,
            age: 25,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 191,
            age: 25,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 192,
            age: 26,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 193,
            age: 26,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 194,
            age: 27,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 195,
            age: 27,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 196,
            age: 28,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 197,
            age: 28,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 198,
            age: 29,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 199,
            age: 29,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 200,
            age: 30,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 201,
            age: 30,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 202,
            age: 31,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 203,
            age: 31,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 204,
            age: 32,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 205,
            age: 32,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 206,
            age: 33,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 207,
            age: 33,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 208,
            age: 34,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 209,
            age: 34,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 210,
            age: 35,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 211,
            age: 35,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 212,
            age: 37,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 213,
            age: 37,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 214,
            age: 38,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 215,
            age: 38,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 216,
            age: 39,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 217,
            age: 39,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 218,
            age: 40,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 219,
            age: 40,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 220,
            age: 41,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 221,
            age: 41,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 222,
            age: 42,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 223,
            age: 42,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 224,
            age: 43,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 225,
            age: 43,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 226,
            age: 44,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 227,
            age: 44,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 228,
            age: 45,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 229,
            age: 45,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 230,
            age: 46,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 231,
            age: 46,
            isBaby: true,
            isBoy: false,
        },
        {
            code: 232,
            age: 47,
            isBaby: true,
            isBoy: true,
        },
        {
            code: 233,
            age: 47,
            isBaby: true,
            isBoy: false,
        },
    ],
});
